import config from "../../config"
import RequestService from "../RequestService"

const fetchTicketImages = (ticketId, successCallback, failureCallback) => {
  RequestService.get(`${config.backendUrl}/ticket_images?ticket_id=${ticketId}`, successCallback, failureCallback)
}

export default fetchTicketImages;